import React, { useContext } from 'react'
import PreviewerPageWrapper from '@apphiveio/controlsmanager/components/PreviewerPageWrapper'
import PreviewerPageSplash from '@apphiveio/controlsmanager/components/PreviewerPageSplash'
import PreviewerContext from '@apphiveio/controlsmanager/PreviewerContext'

const compiledSplashScreenSource = undefined
const loadingMessage = ''
const background = undefined
const backgroundColor = 'white'
// The compilation sets this to true when the client's splash is a Lottie (JSON), so the
// animation fills the screen instead of the 200x200 box used by the default loader.
const splashLottieFullscreen = false

const fullscreenLottieStyle = {
    width: '100%',
    height: '100%',
} as const

const ClientAppSplashScreen = () => {
    const { Render, lottieSources } = useContext(PreviewerContext)

    if (compiledSplashScreenSource) {
        return <PreviewerPageWrapper backgroundSource={compiledSplashScreenSource} />
    }

    if (splashLottieFullscreen) {
        return (
            <PreviewerPageWrapper background={background} backgroundColor={backgroundColor}>
                <Render.View style={fullscreenLottieStyle}>
                    <Render.Lottie source={lottieSources.apphiveLoading} visible loop />
                </Render.View>
            </PreviewerPageWrapper>
        )
    }

    return (
        <PreviewerPageSplash
            message={loadingMessage}
            background={background}
            backgroundColor={backgroundColor}
        />
    )
}

export default ClientAppSplashScreen
